import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "-0.5 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 1C9.97933 1.052 11.6276 1.73702 12.9453 3.05469C14.263 4.37235 14.948 6.02067 15 8C14.948 9.97933 14.263 11.6276 12.9453 12.9453C11.6276 14.263 9.97933 14.948 8 15C6.02067 14.948 4.37235 14.263 3.05469 12.9453C1.73702 11.6276 1.052 9.97933 1 8C1.052 6.02067 1.73702 4.37235 3.05469 3.05469C4.37235 1.73702 6.02067 1.052 8 1ZM8 10.4062C7.77067 10.4066 7.58069 10.4821 7.42969 10.6328C7.27873 10.7835 7.20312 10.9735 7.20312 11.2031C7.20315 11.4327 7.27871 11.6203 7.42969 11.7656C7.58066 11.9109 7.77075 11.989 8 12C8.22925 11.9897 8.41934 11.9115 8.57031 11.7656C8.72128 11.6197 8.79685 11.4321 8.79688 11.2031C8.79688 10.9742 8.72127 10.7841 8.57031 10.6328C8.41931 10.4815 8.22933 10.4059 8 10.4062ZM7.99902 4C7.72852 4.00024 7.50489 4.0992 7.32812 4.29688C7.15112 4.49487 7.07308 4.72933 7.09375 5L7.45312 9C7.47413 9.14599 7.53415 9.26323 7.63281 9.35156C7.73134 9.43968 7.85333 9.48395 7.99902 9.48438C8.14493 9.48471 8.26758 9.44045 8.36621 9.35156C8.46487 9.26257 8.5249 9.14533 8.5459 9L8.90527 5C8.92627 4.729 8.84823 4.49454 8.6709 4.29688C8.49359 4.09929 8.26963 4.00034 7.99902 4Z",
    fill: "var(--fr-faq-icon-color)"
  })
], -1)

import { FrPopover } from "@frisbuy/frisbuy-ui-components";


export default /*#__PURE__*/_defineComponent({
  __name: 'FAQBlock',
  props: {
    text: {}
  },
  setup(__props: any) {

// Modules
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FrPopover), {
    popoverWidth: 300,
    placement: "bottom",
    trigger: "hover",
    "close-delay": 0,
    "hide-after": 0,
    popperClass: "frisbuy-summary-widget__popover",
    popoverOffset: 10
  }, {
    reference: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, _toDisplayString(props.text), 1)
    ]),
    _: 1
  }))
}
}

})